import Vue from 'vue'
import Vuex from 'vuex'

//用户
import user  from './user/user';
//跟团游会员
import toursVip from './toursVip/toursVip';
//商城
import product from './store/store';
//发放优惠券
import member from './member/menber';
//路由记忆
import routerStoe from './routeStorage'

//客户列表
import client from "./client";
//客户池
import cust_pool from "./custPool";

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

//实例化 Vuex.store
const store  = new Vuex.Store({
    modules:{
        user,
        toursVip,
        product,
        routerStoe,
        client,
        cust_pool
    },
  plugins: [createPersistedState({
    storage:window.sessionStorage,
    reducer(val)  {
      return {
        routerStoe: val.routerStoe  //存储路由记忆
      }
    }
  })]
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js